@if (type().key === "Regard_3000_plus" || type().key === "Regard_7000") {
  <app-product-card-with-quantity
    [productData]="gasWarningCenterData()"
    [showCosts]="showCosts()"
    [quantity]="quantity()"
    [selectionMode]="selectionMode()"
    [imageUrl]="imageUrl()"
    [fallbackImageUrl]="fallbackImageUrl()"
    (quantityChanged$)="quantityChanged$.emit($event)"
  >
    <ng-container *ngTemplateOutlet="productFeatures"></ng-container>
  </app-product-card-with-quantity>
} @else {
  <app-product-card
    [product]="gasWarningCenterData()"
    [showCosts]="showCosts()"
    [selectionMode]="selectionMode()"
    [isSelected]="quantity() > 0"
    [imageUrl]="imageUrl()"
    [fallbackImageUrl]="fallbackImageUrl()"
    (select$)="quantityChanged$.emit(1)"
  >
    <ng-container *ngTemplateOutlet="productFeatures"></ng-container>
  </app-product-card>
}
<ng-template #productFeatures>
  <div class="feature">
    <p class="p-label odx-text--small" i18n="@@global.partNumber">Sachnummer</p>
    <p class="odx-text--small">{{ gasWarningCenterData().id }}</p>
  </div>
  @if (powersupplyProperty) {
    <div class="feature">
      <p class="odx-text--small p-label">{{ powersupplyProperty.name }}</p>
      <p class="odx-text--small">{{ powersupplyProperty.value }}</p>
    </div>
  }
  @if (dimensionsProperty) {
    <div class="feature">
      <p class="odx-text--small p-label">{{ dimensionsProperty.name }}</p>
      <p class="odx-text--small" i18n="@@gasWarningCenterConfiguration.gasWarningCenterCard.dimensions">
        ({{ dimensionsProperty.height * 1000 }}mm × {{ dimensionsProperty.width * 1000 }}mm ×
        {{ dimensionsProperty.depth * 1000 }}mm)
      </p>
    </div>
  }
  @if (degreeprotectionProperty) {
    <div class="feature">
      <p class="odx-text--small p-label">{{ degreeprotectionProperty.name }}</p>
      <p class="odx-text--small">{{ degreeprotectionProperty.value }}</p>
    </div>
  }

  @if (productInfoUrl()) {
    <div class="link-row" odxLayout="flex">
      <a odxLink class="card-link" [href]="productInfoUrl()" target="_blank" (click)="$event.stopPropagation()">
        <odx-icon name="document" inline></odx-icon>
        <span i18n="@@global.productDatasheet">Produktdatenblatt</span>
      </a>
    </div>
  }
  <div class="link-row" odxLayout="flex">
    @if (type().hasExcelsheet) {
      <a
        odxLink
        class="card-link"
        [href]="'/assets/products/excelsheets/' + type().key + '.xlsm'"
        target="_blank"
        (click)="$event.stopPropagation()"
      >
        <odx-icon name="document" inline></odx-icon>
        <span i18n="@@gasWarningCenterConfiguration.gasWarningCenterCard.excelSheetLinkText"
          >Konfiguration {{ type().name }}</span
        >
      </a>
    }
  </div>
</ng-template>
